import LargeTextInputBlock from './LargeTextInputBlock';

export default LargeTextInputBlock;
